<template>
    <!-- appBanner 管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'appBanner')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="是否展示">
                        <a-select allowClear placeholder="请选择" v-decorator="['isEnable']"  @select="getList">
                            <a-select-option :value="1">是</a-select-option>
                            <a-select-option :value="0">否</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="getList" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <a-button slot="tabBarExtraContent" icon="plus" v-if="getBtnByAuth('addBanner')" class="mb16" type="primary" @click="toAddBanner()">新建</a-button>
                <a-table bordered @change="changePage" :dataSource="dataSource" :columns="columns" :pagination="pagination" :rowKey="record => record.id">    
                    <span slot="index" slot-scope="a, row, index">{{index+1}}</span>
                    <span slot="empty" slot-scope="empty">{{empty || '--'}}</span>
                    <template slot="isEnable" slot-scope="isEnable">
                        {{isEnable ? '是' : '否'}}
                    </template>
                    <div slot="imgUrl" slot-scope="imgUrl,row">
                        <img class="banner-img" preview @click="toPreview(row)" :src="row.imgUrlLittle" alt />
                    </div>
                    <template slot="shopId" slot-scope="shopId">
                        {{shopList.filter(e => e.id == shopId).length > 0 ? shopList.filter(e => e.id == shopId)[0].name : '--'}}
                    </template>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('updateBanner')">
                            <a @click="openUp(row)" class="text-primary">上下架</a>
                            <a-divider type="vertical"/>
                        </span>
                        <span v-if="getBtnByAuth('updateBanner')">
                            <a v-if="!row.isEnable" @click="toUpdateBanner(row.id)" class="text-primary">编辑</a>
                            <span v-else class="text-disabled">编辑</span>
                            <a-divider type="vertical"/>
                        </span>
                        <a v-if="getBtnByAuth('bannerDetail')" @click="toDetailBanner(row.id)" class="text-primary">详情<a-divider type="vertical"/></a>
                        
                        <span v-if="getBtnByAuth('bannerTop')">
                            <a v-if="row.isEnable" @click="topBanner(row.id)" class="text-primary">顺序置顶</a>
                            <span v-else class="text-disabled">顺序置顶</span>
                            <a-divider v-if="getBtnByAuth('bannerDelete')" type="vertical"/>
                        </span>

                        <template v-if="getBtnByAuth('bannerDelete')">
                            <a-popconfirm
                                title="是否确认删除？"
                                @confirm="deleteBanner(row.id)"
                                okText="确定"
                                cancelText="取消"
                                v-if="!row.isEnable"
                            >
                                <a class="text-primary">删除</a>
                            </a-popconfirm>
                            <span v-else class="text-disabled">删除</span>
                        </template>
                    </span>
                </a-table>
            </a-card>
            <a-modal title="展示时间修改" :visible="showUp" @ok="onChangeStatus" @cancel="showUp = false" centered >
                <a-form :form="formModal" >
                    <a-form-item label="开始展示时间" :labelCol="labelCol" :wrapperCol="wrapperCol" required >
                        <a-date-picker show-time placeholder="请选择" v-decorator="['effectiveStart', {rules: [{required: true, message: '请选择开始展示时间'}]}]" />
                    </a-form-item>
                    <a-form-item label="结束展示时间" :labelCol="labelCol" :wrapperCol="wrapperCol" required >
                        <a-radio-group @change="onChangeTime"
                        v-decorator="['endLabel', {initialValue: 0}]">
                            <a-radio :value="0">暂不设置</a-radio>
                            <a-radio :value="1">定时结束展示</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :required="false" v-show="formModal.getFieldValue('endLabel') == 1" label=" " :colon="false"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
                        <a-date-picker show-time placeholder="请选择" v-decorator="['effectiveEnd', {rules: [{required: formModal.getFieldValue('endLabel') == 1, message: '请选择定时结束时间'}]}]" />
                    </a-form-item>
                </a-form>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const tabListNoTitle = [
        {
            key: 'header',
            tab: '首页头图',
            columnLine: columns
        },
        {
            key: 'banner',
            tab: '首页banner',
            columnLine: columns
        },
    ]
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "图片",
        width: 300,
        dataIndex: "imgUrlThumb",
        scopedSlots: { customRender: "imgUrl" }
    },
    {
        title: "展示开始时间",
        dataIndex: "effectiveStart",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "展示结束时间",
        dataIndex: "effectiveEnd",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "适用门店",
        dataIndex: "shopId",
        scopedSlots: { customRender: "shopId" }
    },
    {
        title: "是否展示",
        dataIndex: "isEnable",
        scopedSlots: { customRender: "isEnable" }
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }];
    export default {
        name: "appBanner",
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 5
                },
                tabListNoTitle,
                noTitleKey: 'header',
                labelCol: {span: 8},
                wrapperCol: {span: 16},
                showUp: false,
                id: '',
                shopList: []
            };
        },
        methods: {
            toPreview(row) {
                row.imgUrlLittle = row.imgUrl;
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            handleReset() {
                this.form.resetFields();
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey;
                this.pagination.current = 1;
                this.getList();
            },
            onChangeTime (e) {
                this.$nextTick(() => {
                    this.formModal.validateFields(['effectiveStart','effectiveEnd'], { force: true });
                });
            },
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.$api.operation.bannerList({
                        body: Object.assign(values, {
                            shopId: this.shopId == '-1' ? undefined : this.shopId,
                            bannerType: this.noTitleKey,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    }).then(res => {
                        res.list.map(e => {
                            e.imgUrlLittle = e.imgUrl + '?x-oss-process=image/resize,w_206/quality,q_60';
                            return e;
                        })
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    });
                });
            },
            // 系统店铺获取
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                });
            },
            // 跳转至新增
            toAddBanner() {
                this.$router.push({
                    name: "addBanner",
                    query: {type: this.noTitleKey}
                });
            },

            // 跳转至编辑
            toUpdateBanner(id) {
                this.$router.push({
                    name: "updateBanner",
                    query: { id: id}
                });
            },

            // 跳转至详情
            toDetailBanner(id) {
                this.$router.push({
                    name: "bannerDetail",
                    query: { id: id}
                });
            },

            // 置顶
            topBanner(id) {
                this.$api.operation.topBanner({
                    params: {id: id}
                }).then(res => {
                    this.$message.success('操作成功', 2);
                    this.getList();
                })
            },

            // 删除
            deleteBanner(id) {
                this.$api.operation.deleteBanner({
                    params: {id: id}
                }).then(res => {
                    this.$message.success('操作成功', 2);
                    this.getList();
                })
            },

            openUp(row) {
                this.showUp = true;
                this.id = row.id;
                let values = {
                    endLabel: row.effectiveEnd ? 1 : 0,
                    effectiveStart: row.effectiveStart || null,
                    effectiveEnd: row.effectiveEnd || null,
                }
                this.$nextTick(() => {
                    this.formModal.setFieldsValue(
                        values
                    )
                })
            },
            // 冻结解冻
            onChangeStatus() {
                this.formModal.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    if(values.endLabel == 1 && this.$moment(values.effectiveEnd) - this.$moment(values.effectiveStart) <= 0) {
                        this.$message.warning('结束展示时间不能早于开始展示时间')
                        return
                    }
                    values.effectiveStart = this.$moment(values.effectiveStart).format('YYYY-MM-DD HH:mm:ss');
                    values.effectiveEnd = values.endLabel == 1 ? this.$moment(values.effectiveEnd).format('YYYY-MM-DD HH:mm:ss') : null;
                    delete values.endLabel
                    this.$api.operation.state({
                        body: Object.assign(values,
                            {
                                id: this.id
                            }
                        )
                    }).then(res => {
                        this.$message.success('操作成功', 2);
                        this.getList();
                        this.showUp = false
                    })
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.formModal = this.$form.createForm(this);
        },
        mounted() {
            this.getList();
            this.getShopList();
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            $route(val) {
                val.name == "appBanner" && this.getList();
            },
            'shopId'() {
                this.getList()
            },
        }
    };
</script>
<style lang="scss">
    .banner-img {
        width: 206px;
        height: 115px;
    }
</style>